export function isFocusWithinSupported(): boolean {
  try {
    document.querySelector(':focus-within')
  } catch (error) {
    return false
  }

  return true
}
